import {
  Wallet,
  TrendUp,
  TrendDown,
  CurrencyDollar,
  Percent,
  Trophy,
  LockOpen,
  Lock,
  Briefcase,
} from "@phosphor-icons/react";
import { getCardClass, getTextPrimary, getTextSecondary } from "../../lib/styleHelpers";

function formatCurrency(val) {
  if (val >= 1000000) return `$${(val / 1000000).toFixed(1)}M`;
  if (val >= 1000) return `$${(val / 1000).toFixed(1)}K`;
  return `$${val.toFixed(2)}`;
}

function SummaryMetric({ icon: Icon, label, value, color, isDark, testId }) {
  return (
    <div className={`p-4 rounded-xl border ${getCardClass(isDark)}`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon size={18} className={getTextSecondary(isDark)} />
        <span className={`text-xs font-body ${getTextSecondary(isDark)}`}>{label}</span>
      </div>
      <p className={`text-2xl font-bold ${color}`} data-testid={testId}>{value}</p>
    </div>
  );
}

function SecondaryMetric({ icon: Icon, label, value, iconColor, isDark, testId }) {
  return (
    <div className={`p-3 rounded-xl border ${getCardClass(isDark)}`}>
      <div className="flex items-center gap-2 mb-1">
        <Icon size={14} className={iconColor} />
        <span className={`text-xs ${getTextSecondary(isDark)}`}>{label}</span>
      </div>
      <p className={`text-lg font-bold ${getTextPrimary(isDark)}`} data-testid={testId}>{value}</p>
    </div>
  );
}

export function PortfolioSummaryCards({ summary, isDark }) {
  if (!summary) return null;

  const pnlColor = summary.total_pnl >= 0 ? "text-emerald-500" : "text-red-500";
  const roiColor = summary.total_roi_percent >= 0 ? "text-emerald-500" : "text-red-500";

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="portfolio-summary">
        <SummaryMetric icon={Wallet} label="Total Invested" value={formatCurrency(summary.total_invested)} color={getTextPrimary(isDark)} isDark={isDark} testId="summary-invested" />
        <SummaryMetric icon={CurrencyDollar} label="Current Value" value={formatCurrency(summary.total_current_value)} color={getTextPrimary(isDark)} isDark={isDark} testId="summary-current" />
        <SummaryMetric icon={summary.total_pnl >= 0 ? TrendUp : TrendDown} label="Total P&L" value={`${summary.total_pnl >= 0 ? "+" : ""}${formatCurrency(Math.abs(summary.total_pnl))}`} color={pnlColor} isDark={isDark} testId="summary-pnl" />
        <SummaryMetric icon={Percent} label="Total ROI" value={`${summary.total_roi_percent >= 0 ? "+" : ""}${summary.total_roi_percent}%`} color={roiColor} isDark={isDark} testId="summary-roi" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <SecondaryMetric icon={LockOpen} label="Open" value={summary.open_positions} iconColor="text-blue-500" isDark={isDark} testId="summary-open" />
        <SecondaryMetric icon={Lock} label="Closed" value={summary.closed_positions} iconColor="text-gray-500" isDark={isDark} testId="summary-closed" />
        <SecondaryMetric icon={Trophy} label="Win Rate" value={`${summary.win_rate}%`} iconColor="text-amber-500" isDark={isDark} testId="summary-winrate" />
        <SecondaryMetric icon={Briefcase} label="Total Positions" value={summary.total_positions} iconColor="text-purple-500" isDark={isDark} testId="summary-total" />
      </div>
    </>
  );
}
